export const balanceBoxWidth = 380;
